import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const SalesTraining = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, salesTraining: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false);
	}

	const steps = [
		{
			target: '.salesTrainingFirstStep',
			title: "Select Training",
			content: 'Select training name.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.salesTrainingSecondStep',
			title: "Select Start Date",
			content: 'Choose the starting date for viewing sales data.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.salesTrainingThirdStep',
			title: "Select End Date",
			content: 'Choose the ending date for viewing sales data.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.salesTrainingFourthStep',
			title: "Search Sales",
			content: 'Search to see specific training sales data.',
			disableBeacon: true,
			placement: "bottom",
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.salesTrainingFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.salesTraining)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="salesTraining" 
			featureName="sales"
		/>
	);
}
